
          import p from "/home/nathan/goalert/web/src/app/public/logos/white/goalert-alt-logo-white.png"
          const prefixPath = pathPrefix + "/static/" + p
          export default prefixPath
        